import { alpha, Theme } from '@mui/material';

// Figma tag component 416:9171 (file CE8J0urthchLLY6jWZMs6O). Geometry belongs to the Tag component
// itself and is tone-independent in Figma. Colors are NOT part of this constant on purpose — every
// tone must come from the theme palette (see amberTagSx / the MuiChip 'tag' variant).
export const TAG_GEOMETRY = {
    radius: '3px',
    height: 18,
    paddingX: '8px',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
} as const;

// Shared shape for the hand-rolled amber pills that are not MUI Chips (KG open-items cell, status /
// steward summary pills, stage tag, segmented-picker count badge). Amber is the one tone whose own
// hue is unreadable as text on its own fill, so it pairs with the default text color. Kept a plain
// object (call sites spread it: `{ ...amberTagSx, flexShrink: 0 }`) — the colors resolve through the
// theme via sx value callbacks, never hard-coded.
export const amberTagSx = {
    display: 'inline-flex',
    alignItems: 'center',
    height: `${TAG_GEOMETRY.height}px`,
    padding: `0 ${TAG_GEOMETRY.paddingX}`,
    borderRadius: TAG_GEOMETRY.radius,
    fontSize: TAG_GEOMETRY.fontSize,
    lineHeight: TAG_GEOMETRY.lineHeight,
    fontWeight: TAG_GEOMETRY.fontWeight,
    whiteSpace: 'nowrap',
    backgroundColor: (theme: Theme) => alpha(theme.palette.warning.main, 0.32),
    color: 'text.primary',
} as const;
